import { render, staticRenderFns } from "./UserWorkshopModal.vue?vue&type=template&id=5752d7c4&scoped=true&"
import script from "./UserWorkshopModal.vue?vue&type=script&lang=js&"
export * from "./UserWorkshopModal.vue?vue&type=script&lang=js&"
import style0 from "./UserWorkshopModal.vue?vue&type=style&index=0&id=5752d7c4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5752d7c4",
  null
  
)

export default component.exports